import * as M from 'shared/types/models';

export function normalize(x: M.Range): M.Range {
  return x.start > x.end
    ? { start: x.end, end: x.start }
    : x;
}
